import { useDidYouMeanZeroResultSearchesExperiment } from '@/utils/amplitude/experiments/hooks/useDidYouMeanZeroResultSearches.experiment';

/**
 * Mounted conditionally so exposure only fires on typed keyword SRPs, the pages where either arm
 * can differ (corrected results, or the hidden "Looking for [House]?" link).
 */
export const DidYouMeanZeroResultSearchesExposure = () => {
    useDidYouMeanZeroResultSearchesExperiment();
    return null;
};
